<template>
  <v-dialog v-model="data.dialog" persistent max-width="600px">
    <v-card v-if="loading" :color="isDelete ? 'error' : 'primary'" dark>
      <v-card-text>
        <span class="font-weight-bold text-white">{{ $t('loading') }}</span>
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
    <v-card v-if="!loading">
      <v-card-title
        :class="{'form-danger': isDelete, 'form-info': isUpdate, 'form-primary': isCreate}"
      >
        <span v-if="isCreate" class="">{{ $('create') }}</span>
        <span v-if="isUpdate" class="">{{ $('update') }}</span>
        <span v-if="isDelete" class="">{{ $('delete') }}</span>
      </v-card-title>
      <v-card-text>
        <h2 v-if="isDelete && item" class="my-3">
          {{ $('delete_msg', [item.title]) }}
        </h2>
        <v-form
          v-if="!isDelete"
          ref="form"
          v-model="valid"
        >
          <v-container v-if="isCreate || isUpdate">
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="form.title"
                  v-max-length="200"
                  label="عنوان الاعلان"
                  :rules="rules.title"
                  autocomplete="new-password"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="form.link"
                  v-max-length="200"
                  label="الرابط (عند الضغط)"
                  :rules="rules.link"
                  autocomplete="new-password"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="12"
              >
                <v-text-field
                  v-model="form.expire"
                  v-max-length="200"
                  type="date"
                  label="تاريخ النفاذ"
                  :rules="rules.expire"
                  autocomplete="new-password"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                :cols="imagePreview ? 9 : 12"
              >
                <v-file-input
                  ref="file"
                  v-model="form.banner"
                  type="file"
                  accept="image/png, image/jpeg, image/bmp"
                  placeholder="اختر صورة الاعلان"
                  prepend-icon="mdi-camera"
                  label="صورة الاعلان"
                  @change="fileChanged"
                ></v-file-input>
              </v-col>
              <v-col
                v-if="imagePreview"
                cols="3"
              >
                <v-avatar
                  color=""
                  class="v-avatar-light-bg primary--text mb-1 "
                  size="100"
                  rounded
                >
                  <v-img
                    :src="imagePreview"
                  >
                  </v-img>
                </v-avatar>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="light"
          outlined
          @click="dialogModal(false)"
        >
          {{ $t('form.cancel') }}
        </v-btn>
        <v-btn
          v-if="isCreate"
          color="primary"
          :disabled="!valid || submitLoading"
          :loading="submitLoading"
          @click="submit"
        >
          {{ $t('form.create') }}
        </v-btn>
        <v-btn
          v-if="isUpdate"
          color="info"
          :disabled="!valid || submitLoading"
          :loading="submitLoading"
          @click="submit"
        >
          {{ $t('form.save') }}
        </v-btn>
        <v-btn
          v-if="isDelete"
          color="error"
          :disabled="submitLoading"
          :loading="submitLoading"
          @click="submit"
        >
          {{ $t('form.delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from '@axios'
import toast from '@/store/toast'

export default {
  name: 'Dialog',
  props: {
    data: {
      type: Object,
      default: () => ({
        dialog: false,
        id: null,
        type: 'create',
      }),
    },
    dialogModal: {
      type: Function,
      default: state => {
        this.data.dialog = state
      },
    },
    translationKey: {
      type: String,
      default: () => '',
    },
  },
  emits: ['update:table'],
  data: () => ({
    loading: true,
    submitLoading: false,
    valid: false,
    hidePassword: true,
    imagePreview: null,
    form: {
      id: '',
      title: '',
      link: '',
      expire: '',
      banner: null,
    },
  }),
  computed: {
    isCreate() {
      return this.data.type === 'create'
    },
    isUpdate() {
      return this.data.type === 'update'
    },
    isDelete() {
      return this.data.type === 'delete'
    },
    rules() {
      const rules = {};
      rules.title = [
        v => !!v || this.$t('form.required', ['عنوان الاعلان']),
      ];
      rules.expire = [
        v => !!v || this.$t('form.required', ['تاريخ النفاذ']),
      ];

      return rules;
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      async handler(val) {
        try {
          this.loading = true;
          if (val.data) {
            this.item = val.data;
            this.form.id = val.data.id;
            this.form.title = val.data.title;
            this.form.expire = val.data.expire.substring(0, 10);
            this.form.link = val.data.link;
            this.imagePreview = val.data.banner;
          }
          if (!val.dialog) {
            this.resetForm();
          }
        } catch (error) {
          //   await toast.dispatch('error', error.response ? error.response.data.message : error.message)
        } finally {
          this.loading = false;
        }
      },
    },
  },
  methods: {
    async submit() {
      try {
        const formData = new FormData();
        formData.append('id', this.form.id);
        this.submitLoading = true;
        if (this.isDelete) {
          await axios.post('/advertisements/delete', formData);
          await toast.dispatch('success', this.$t('form.success.delete'))
          this.$emit('update:table')
          this.dialogModal(false)

          return;
        }
        if (this.$refs.form.validate() === false) {
          return;
        }
        formData.append('title', this.form.title);
        formData.append('link', this.form.link);
        formData.append('banner', this.form.banner);
        formData.append('expire', this.form.expire);
        if (this.isCreate) {
          await axios.post('/advertisements/create', formData);
          await toast.dispatch('success', this.$t('form.success.create'))
        } else if (this.isUpdate) {
          await axios.post('/advertisements/update', formData);
          await toast.dispatch('success', this.$t('form.success.update'))
        }
        this.$emit('update:table')
        this.dialogModal(false)
      } catch (error) {
        //   await toast.dispatch('error', error.response ? error.response.data.message : error.message)
      } finally {
        this.submitLoading = false;
      }
    },
    fileChanged() {
      if (!this.form.banner) {
        this.imagePreview = null

        return null
      }
      const reader = new FileReader()
      reader.readAsDataURL(this.form.banner)
      reader.onload = () => {
        this.imagePreview = reader.result
      }
      reader.onerror = error => {
        console.log('Error: ', error)
      }

      return null
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.imagePreview = null;
      this.item = null;
    },
    $(key, parameters = null) {
      return this.$t(`${this.translationKey}.modal.${key}`, parameters);
    },
  },
}
</script>

<style scoped>

</style>
